import {
    SET_FETCH_ORDER,
    UPDATE_ORDER,
    SET_FETCH_PARTNERS,
    SETCURRENTPAGEANDSIZE,
} from '../ActionTypes/ActionTypes';


const initialState = {
    orders: [],
    partners: [],
    pageNo: 1,
    pageSize: 10,
};

const AllOrdersReducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_FETCH_ORDER:
        return {
            ...state,
            orders: action.payload.data,
        };

    case UPDATE_ORDER:
        state.orders.splice(action.payload.indexAt, 1, action.payload.data);
        return {
            ...state,
        };

    case SET_FETCH_PARTNERS:
        return {
            ...state,
            partners: action.payload.data,
        };

    case SETCURRENTPAGEANDSIZE:
        return {
            ...state,
            pageNo: action.payload.pageNo,
            pageSize: action.payload.pageSize,
        };

    default:
        return state;
    }
};


export default AllOrdersReducer;



// WEBPACK FOOTER //
// ./src/Reducer/AllOrdersReducer.js